<template>
  <div>
    <card>
        <!-- <b-card no-body>
            <b-tabs pills card> -->
                <b-tab title="Tab 1" active>
                    <b-card-text>
                        <h1>CHECK LIST ANALISI INIZIALE ORGANIZZAZIONE E GESTIONE DELLA SALUTE E SICUREZZA SUL LAVORO</h1>
                        <h2>ANAGRAFICA AZIENDALE</h2>
                            <div class="form-group col-md-6">
                        <div class="form-row">
                                <label for="data">Data<span style="color:#ff0000">*</span></label>{{anagrafica.data}}
                                <input type="date" class="form-control" v-model="anagrafica.data">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="ditta">Ditta<span style="color:#ff0000">*</span></label>
                                <input type="text" class="form-control" v-model="anagrafica.ditta">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="n_sedi">N. Sedi</label>
                                <input type="number" class="form-control" v-model="anagrafica.n_sedi">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="sede_operativa">1. Sede operativa<span style="color:#ff0000">*</span></label>
                                <input type="text" class="form-control" v-model="anagrafica.sede_operativa">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="sede_legale">2. Sede legale (se diversa)</label>
                                <input type="text" class="form-control" v-model="anagrafica.sede_legale">
                            </div>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-2">
                                <label for="n_soci">N. Soci<span style="color:#ff0000">*</span></label>
                                <input type="number" class="form-control" v-model="anagrafica.n_soci">
                            </div>
                            <div class="form-group col-md-2">
                                <label for="n_soci_lavoratori">di cui lavoratori<span style="color:#ff0000">*</span></label>
                                <input type="number" class="form-control" v-model="anagrafica.n_soci_lavoratori">
                            </div>
                            <div class="form-group col-md-2">
                                <label for="n_dipendenti">N. dipendenti<span style="color:#ff0000">*</span></label>
                                <input type="number" class="form-control" v-model="anagrafica.n_dipendenti">
                            </div>
                            <div class="form-group col-md-2">
                                <label for="n_collaboratori">N. collaboratori<span style="color:#ff0000">*</span></label>
                                <input type="number" class="form-control" v-model="anagrafica.n_collaboratori">
                            </div>
                            <div class="form-group col-md-2">
                                <label for="subapp">Subapp.<span style="color:#ff0000">*</span></label>
                                <input type="number" class="form-control" v-model="anagrafica.subapp">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="interferenze">Interferenze (art. 26)<span style="color:#ff0000">*</span></label>
                                <!-- <input type="text" class="form-control" v-model="interferenze"> -->
                                <textarea lass="form-control" v-model="anagrafica.interferenze" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="descrizione_attivita">Descrizione attività<span style="color:#ff0000">*</span></label>
                                <textarea lass="form-control" v-model="anagrafica.descrizione_attivita" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                        <h3>Orario di lavoro</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-4">
                                <label for="n_ore_settimanali">N° ore settimanali<span style="color:#ff0000">*</span></label>
                                <input type="number" class="form-control" v-model="anagrafica.n_ore_settimanali">
                            </div>
                            <div class="form-group col-md-4">
                                <div class="form-row justify-content-md-center">
                                    <label class="label-switch">Orario Notturno</label>
                                </div>
                                <div class="form-row justify-content-md-center">
                                    <label class="switch">
                                        <input type="checkbox" class="form-control" v-model="anagrafica.orario_notturno"><span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-2" v-if="anagrafica.orario_notturno">
                                <label for="orario_dalle">Dalle<span style="color:#ff0000">*</span></label>
                                <input type="time" class="form-control" v-model="anagrafica.orario_dalle">
                            </div>
                            <div class="form-group col-md-2" v-if="anagrafica.orario_notturno">
                                <label for="orario_alle">Alle<span style="color:#ff0000">*</span></label>
                                <input type="time" class="form-control" v-model="anagrafica.orario_alle">
                            </div>
                        </div>
                         <div class="form-row">
                            <div class="form-group col-md">
                                <label for="mansioni_dipendenti">Mansioni dipendenti<span style="color:#ff0000">*</span></label>
                                <textarea lass="form-control" v-model="anagrafica.mansioni_dipendenti" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                         <div class="form-row">
                            <div class="form-group col-md">
                                <label for="note">Note</label>
                                <textarea lass="form-control" v-model="anagrafica.note" rows="3" style="width:100%;border-radius:7px"></textarea>
                            </div>
                        </div>
                    </b-card-text>
                </b-tab>
            <!-- <button v-on:click="addAnagraficaValori()" class="btn"></button> -->

            <!-- </b-tabs>
        </b-card> -->

        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriIdentificazione()" style="margin-top: 10px;background:#00467f">Salva</button> -->
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriDati()" style="margin-top: 10px;background:#00467f">Salva</button>
        <router-link :to="'valutazione-a?idCliente='+idCliente"><button class="btn float-right" type="button" style="margin-top: 10px;margin-right:20px;background:#00467f">Avanti</button></router-link>
        <router-link to="/clienti" class="btn float-right" style="margin-top: 10px;margin-right:10px;background:#00467f">Indietro</router-link> -->
        
    </card>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card.vue";
import Services from '@/services/Services';

export default {
    props: ['anagraficaValori'],
    components: {
        Card
    },

    data() {
        return {
            anagrafica: {},
            // TAB 1
            // data: null,
            // ditta: null,
            // n_sedi: null,
            // sede_operativa: null,
            // sede_legale: null,
            // n_soci: null,
            // n_soci_lavoratori: null,
            // n_dipendenti: null,
            // n_collaboratori: null,
            // subapp: null,
            // interferenze: null,
            // descrizione_attivita: null,
            // n_ore_settimanali: null,
            // orario_notturno: false,
            // orario_dalle: null,
            // orario_alle: null,
            // mansioni_dipendenti: null,
            // note: null,

            idCliente: null,
            idSoggetto: null,
        }
    },
    props: {
        anagraficaValori: {
            type: Object,
            required: true
        }
    },
    computed: {},

    methods: {
        addAnagraficaValori() {
            this.anagrafica = Object.assign({}, this.anagraficaValori);
            console.log(`tab1 anagrafica: `);
            console.log(this.anagrafica);
            console.log(`tab1 anagraficaValori: `);
            console.log(this.anagraficaValori);
            console.log(`anagrafica.data = ${this.anagrafica.data}`);
            console.log(`anagraficaValori.data = ${this.anagraficaValori.data}`);
        },

        // checkData: function() {
            // if () {
            //     alert("Compilare tutti i dati!");
            //     return false;
            // } else {
            //     return true;
            // }
        // },


        // salvaValoriDati: async function() {
        //     let errore = 0;
        //     let dati = [];
        //     dati.push({ 
        //        });
        //     let datiJSON=JSON.stringify(dati[0]);
        //     let salvaValori = [];
            // await AntiriciclaggioServices.updateSoggetto(datiJSON, this.idCliente, this.idSoggetto) 
            // .then(response => { salvaValori= response.data})
            // .catch( function (error) {
            //     if(error.response.status == 401){
            //     errore = error.response.status;
            //     }
            // });
            // if (errore == 401) {
            //     let value = await Services.refreshTokenFunction();
            //     if (value) { await this.salvaValoriDati(); }
            // }
        // },

        // main: async function() {
        //     this.idCliente = this.$route.query.idCliente;
            
        // },
    },

    created() {
        // this.addAnagraficaValori();
    },
    
    // mounted() {
    //     this.main();
    // } 

};
</script>
<style scoped>
    .row-color:hover {
    background-color: #00467f53;
    }
    label {
        font-size: 16px;
    }

    .label-switch {
            position: relative;
        /* display: inline-block; */
        display: table-cell;
        padding-right: 10px;
        padding-left: 10px;
        font-size: 16px;
    }
    .switch {
        position: relative;
        /* display: inline-block; */
        display: table-cell;
        width: 55px;
        height: 34px;
    }

    .switch input { 
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

        .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 0px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }
    input:checked + .slider {
        background-color: #00467f;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #00467f;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }
    .slider.round:before {
        border-radius: 50%;
    }
</style>
